var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPh = function SvgPh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 297.64001 297.64001",
    height: 297.64001,
    width: 297.64001,
    xmlSpace: "preserve",
    id: "svg2"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,297.64)",
    id: "g10"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(0.1)",
    id: "g12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path14",
    style: {
      fill: "#ce0f3e",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "M 2232.3,2232.29 V 0 H 0 v 2232.29 h 2232.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path16",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 265.898,198.41 v 94.809 H 374.199 V 198.41 h 17.852 V 396.852 H 374.199 V 309.738 H 265.898 v 87.114 H 248.047 V 198.41 h 17.851 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillrule: "evenodd",
      stroke: "none"
    },
    d: "m 451.074,198.41 20.899,53.578 h 98.632 l 21.172,-53.578 h 19.512 L 532.148,396.852 H 511.25 L 432.656,198.41 h 18.418 z m 26.66,70.102 43.692,111.82 42.871,-111.82 h -86.563 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillrule: "evenodd",
      stroke: "none"
    },
    d: "m 660.957,292.961 h 49.18 c 35.996,0 38.75,-7.981 42.89,-53.34 1.094,-14.019 2.188,-28 6.836,-41.211 h 20.625 c -7.968,12.09 -6.855,26.961 -10.449,59.07 -2.48,23.122 -7.969,40.129 -33.223,44.29 v 0.531 c 23.047,5.738 38.164,21.129 38.164,42.597 0,18.922 -6.562,33.243 -20.332,41.5 -15.097,9.321 -29.394,10.454 -46.718,10.454 H 643.086 V 198.41 h 17.871 v 94.551 z m 0,16.488 v 70.883 h 40.117 c 18.946,0 54.688,2.746 54.688,-35.434 0,-33.828 -31.328,-35.449 -56.621,-35.449 h -38.184 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 906.543,299.57 v -16.511 h 49.766 v -64.02 c -14.024,-4.117 -29.161,-8.238 -44.004,-8.238 -53.575,0 -74.727,36.25 -74.727,86.808 0,41.231 17.871,86.86 65.41,86.86 23.614,0 45.86,-11.27 49.453,-36.578 h 20.352 c -3.027,35.187 -36.836,53.078 -69.805,53.078 -57.422,0 -84.648,-52.258 -84.648,-103.36 0,-61.007 30.508,-103.32 84.648,-103.32 25.547,0 47.266,3.031 71.172,12.371 v 92.91 h -67.617 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillrule: "evenodd",
      stroke: "none"
    },
    d: "m 1043.91,292.961 h 49.18 c 36.03,0 38.78,-7.981 42.9,-53.34 1.09,-14.019 2.19,-28 6.86,-41.211 h 20.6 c -7.97,12.09 -6.85,26.961 -10.43,59.07 -2.48,23.122 -7.97,40.129 -33.26,44.29 v 0.531 c 23.09,5.738 38.2,21.129 38.2,42.597 0,18.922 -6.58,33.243 -20.33,41.5 -15.15,9.321 -29.43,10.454 -46.75,10.454 h -64.84 V 198.41 h 17.87 v 94.551 z m 0,16.488 v 70.883 h 40.13 c 18.95,0 54.69,2.746 54.69,-35.434 0,-33.828 -31.35,-35.449 -56.62,-35.449 h -38.2 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 1337.89,198.41 v 16.512 h -104.14 v 77.726 h 96.17 v 16.493 h -96.17 v 71.191 h 100.01 v 16.52 H 1215.89 V 198.41 h 122 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path28",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillrule: "evenodd",
      stroke: "none"
    },
    d: "m 1388.86,198.41 20.9,53.578 h 98.65 l 21.16,-53.578 h 19.49 l -79.12,198.442 h -20.9 L 1370.46,198.41 h 18.4 z m 26.66,70.102 43.69,111.82 42.87,-111.82 h -86.56 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path30",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 1561.36,396.852 h -19.49 l 72.54,-198.442 h 20.33 l 71.72,198.442 h -17.85 l -62.93,-180.571 h -0.55 l -63.77,180.571 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 1863.55,198.41 v 16.512 h -104.2 v 77.726 h 96.19 v 16.493 h -96.19 v 71.191 h 100.08 v 16.52 H 1741.5 V 198.41 h 122.05 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 2033.22,250.68 c 0,68.379 -112.11,42.851 -112.11,99.16 0,24.18 25.53,34.629 46.19,34.629 20.35,0 42.58,-6.328 43.11,-30.778 h 19.27 c -4.41,38.2 -38.45,47.278 -64.61,47.278 -31.32,0 -63.16,-18.981 -63.16,-53.629 0,-42.852 48.87,-53.012 81.05,-63.731 16.76,-5.468 31.06,-14.847 31.06,-34.629 0,-25.269 -25.55,-38.179 -47.83,-38.179 -26.68,0 -49.22,8.75 -49.75,39.308 h -19.26 c 0.88,-32.711 27.52,-55.82 59.08,-55.82 39.87,0 76.96,13.211 76.96,56.391 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path36",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillrule: "evenodd",
      stroke: "none"
    },
    d: "m 973.438,496.031 v 86.289 h 31.852 c 38.23,-0.82 81.06,8.809 81.06,56.051 0,47.27 -42.83,56.879 -81.06,56.059 H 955.566 V 496.031 h 17.872 z m 0,181.91 h 43.402 c 26.68,0 50.29,-8.531 50.29,-39.57 0,-31.051 -23.61,-39.59 -50.29,-39.59 h -43.402 v 79.16 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillrule: "evenodd",
      stroke: "none"
    },
    d: "m 1105.74,496.031 20.92,53.571 h 98.63 l 21.17,-53.571 h 19.53 l -79.16,198.399 h -20.9 l -78.59,-198.399 h 18.4 z m 26.68,70.059 43.69,111.851 L 1219,566.09 h -86.58 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path40",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "M 1420.05,496.031 V 512.5 h -99.74 v 181.93 h -17.85 V 496.031 h 117.59 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path42",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "m 1477.73,496.031 v 182.52 h 0.55 l 75.84,-182.52 h 17.85 l 75.86,183.258 h 0.54 V 496.031 h 17.88 V 694.43 h -27.21 l -76.13,-172.828 -74.48,172.828 h -28.55 V 496.031 h 17.85 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path44",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillrule: "nonzero",
      stroke: "none"
    },
    d: "M 1845.33,496.031 V 512.5 h -104.16 v 77.789 h 96.19 v 16.461 h -96.19 v 71.191 h 100.04 V 694.43 H 1723.3 V 496.031 h 122.03 v 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path46",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillrule: "evenodd",
      stroke: "none"
    },
    d: "m 1911.97,590.559 h 49.2 c 36.05,0 38.73,-7.969 42.89,-53.36 1.09,-13.961 2.2,-27.969 6.83,-41.168 h 20.63 c -7.95,12.11 -6.86,26.891 -10.47,59.078 -2.42,23.09 -7.95,40.121 -33.18,44.219 v 0.551 c 23.02,5.781 38.12,21.152 38.12,42.621 0,18.961 -6.56,33.262 -20.29,41.5 -15.1,9.332 -29.4,10.43 -46.72,10.43 h -64.86 V 496.031 h 17.85 v 94.528 z m 0,16.511 v 70.871 h 40.15 c 18.93,0 54.67,2.758 54.67,-35.441 0,-33.789 -31.29,-35.43 -56.58,-35.43 h -38.24 v 0"
  }))));
};
export default SvgPh;